export default {"src":"/_next/static/media/partners-background.fe0b1fdd.svg","height":1026,"width":1440,"blurWidth":0,"blurHeight":0};